import { render } from "./ChangePassword.vue?vue&type=template&id=3a1afb00&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=3a1afb00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a1afb00"

export default script